<!-- eslint-disable vue/valid-template-root -->
<template></template>

<script>
import { clientsHasCoupons } from './clientsHasCoupons'

const BEAMER_ID = 'jHsoFxau48486'

export default {
  name: 'Beamer',
  mounted() {
    const { id_user, id_external, name, username, client, is_franchise, is_franchisee, franchise_id, has_mercapromo, only_mercapromo } = this.$getLoggedUser()
    const ID_SMART = '5f4f79598d1bea1cab7c718c'

    let modules = Object.entries(this.$getAllowedModules())
      .filter((module) => module[1])
      .map((module) => module[0])
      .concat('cbm')
      .concat(clientsHasCoupons.includes(id_external) ? 'cupom' : [])
      .concat(has_mercapromo ? 'mercapromo' : [])
      .concat(is_franchise ? 'franquia' : 'varejista')
      .concat(is_franchisee ? 'franqueado' : [])
      .concat(ID_SMART === franchise_id ? 'rede_smart' : '')
      .concat(is_franchise ? 'franquia' : '')
      .concat(is_franchisee ? 'franqueado' : '')
      .join(';')

    if (modules.includes('industry') && !only_mercapromo) modules = modules.concat(';mercatrade')

    const paramsScript = document.createElement('script')
    const inlineCode = document.createTextNode(`
      var beamer_config = {
        product_id : "${BEAMER_ID}",
        user_id : "${id_user}",
        user_firstname : "${name}",
        filter: "${modules}",
        user_client : "${client}",
        user_email : "${username}",
      };
    `)
    paramsScript.appendChild(inlineCode)
    document.head.appendChild(paramsScript)

    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://app.getbeamer.com/js/beamer-embed.js')

    document.head.appendChild(recaptchaScript)
    // time required for bell icon to load
    setTimeout(() => {
      if (window.Beamer) {
        window.Beamer.init()
      }
    }, 800)
  },
  destroyed() {
    window.Beamer.destroy()
  },
}
</script>
